import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl09 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_09",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Warning",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "black",
				d: "M49.73,27h-14.72c-1.08,0-2.06-.56-2.6-1.5-.54-.94-.54-2.06,0-3l7.36-12.74c.54-.94,1.51-1.5,2.6-1.5s2.06.56,2.6,1.5l7.36,12.74c.54.94.54,2.06,0,3-.54.94-1.51,1.5-2.6,1.5ZM41.5,10.76l-7.36,12.73c-.26.45-.09.85,0,1s.34.5.87.5h14.72c.52,0,.78-.35.87-.5s.26-.55,0-1l-7.36-12.73c-.26-.45-.69-.5-.87-.5s-.6.05-.87.5Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "red",
				d: "M41.59,24c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.96-3.42-.39.08c-.35.07-.71-.05-.95-.31-.24-.27-.31-.64-.2-.98l1.57-4.75c.17-.52.73-.81,1.26-.63.52.17.81.74.63,1.26l-1.03,3.11.3-.06c.34-.07.7.04.93.3.24.26.33.62.23.95l-1.41,5c-.12.44-.53.73-.96.73Z"
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "ICE_Sideview",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M37,49H12c-.55,0-1-.45-1-1s.45-1,1-1h25c.55,0,1,.45,1,1s-.45,1-1,1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M28,53H12c-.55,0-1-.45-1-1s.45-1,1-1h16c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-3.69c-.55,0-1-.45-1-1s.45-1,1-1h3.69c5.49,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M24.76,42.78s-.1,0-.15-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-2.09c-.55,0-1-.45-1-1s.45-1,1-1h2.09c3.64,0,7.01.24,10.31.72l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-3c-.55,0-1-.45-1-1s.45-1,1-1h3c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.45.43.48.74s-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
				})
			]
		})]
	})]
});
export default SvgAppIcBefehl09;
